<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('/admin/partners')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Partners</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <b-form-group label="Description">
          <quill-editor
            v-model="description"
            :options="editorOption"
            class="quill-h200px my-2 z-50 relative"
          />
        </b-form-group>

        <FileUploader :image="image" :onSuccess="handleSuccess" />
        <img :src="image" alt="" v-if="image" />
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <!-- <span v-if="imageErr" class="flex justify-center small text-danger">{{
            msg.image
          }}</span> -->

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            :src="$imageURL + '/' + image2"
            alt="uploaded-image"
          />

          <base-button
            v-if="image2"
            type="danger"
            class="px-8"
            @click="handleRemove"
          >
            Remove image
          </base-button>
        </div>

        <div class="py-4 customboxed">
          <p>Redirect Link ( Prefix this link with' https:// ' )</p>
          <base-input
            class="mb-3"
            name="Link"
            placeholder="Add your Page link"
            v-model="link"
          >
          </base-input>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Update</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
// import Data from "../../../../../admin/pages/add-product/components/Data";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
  },
  data() {
    return {
      // title: "",
      link: "",
      description: "",
      image: null,
      image2: "",
      coverImage: null,
      editorOption: {
        theme: "snow",
      },
    };
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      } else if (!image.type.includes("image")) {
        this.$swal.fire({
          title: "File Type!",
          html: "<p style='text-align:center'>Please ensure that the file Type should be Image</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      } else {
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let Regex = /^(|https?:\/\/([a-z0-9-]+\.)+[a-z0-9-]{2,6}(\/[^\s]*)?)$/i;
      if (this.link.trim() !== "" && !Regex.test(this.link.trim())) {
        this.$notify.error({
          message: "Please Enter Valid URL",
          position: "bottom-right",
        });
        return false;
      }

      //  else if (!this.coverImage) {
      //   this.$notify.error({
      //     message: "Please Select Image",
      //     position: "bottom-right",
      //   });

      //   return;
      // }
      if (!this.coverImage && !this.image2) {
        this.$notify.error({
          message: "Please Select Image",
          position: "top-right",
        });
        loader.close();
        return;
      }
      let FormData = require("form-data");
      let data = new FormData();

      data.append("id", this.selectedPartnersForUpdate._id);

      data.append("link", this.link.trim() ? this.link.trim() : "");
      if (this.description) data.append("description", this.description.trim());
      // if (!this.description) {
      //   this.$notify.error({
      //     message: "Description is required  ",
      //     position: "top-right",
      //   });
      //   return;
      // }
      // if (this.coverImage) data.append("picture", this.coverImage);
      if (this.coverImage) {
        data.append("picture", this.coverImage);
      } else if (this.image2) {
        data.append("picture", this.image2);
      }
      let loader = this.$loading();
      try {
        const newsdata = await this.$store.dispatch(
          "partners/updatePartners",
          data
        );

        if (newsdata.code == 200) {
          this.$router.push({ name: "/admin/partners" });
          this.$swal.fire({
            text: "Partners Successfully Updated",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            this.$router.push({ name: "signin" });
            this.$swal.fire({
              title: "Session Expired",
              text: "Your session has ended and for security reasons, we request you to login again",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        }
        loader.close();
      }
    },
    handleRemove() {
      this.image = null;
      this.image2 = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    init() {
      // this.title = this.selectedPartnersForUpdate.title;

      this.link = this.selectedPartnersForUpdate.link;
      this.description = this.selectedPartnersForUpdate.description;
      this.image2 = this.selectedPartnersForUpdate.picture;
      // this.image = `${this.$imageURL}/${this.selectedPartnersForUpdate.picture}`;
      // this.coverImage = this.selectedMedicalForUpdate.picture;
    },
  },
  computed: {
    ...mapState("partners", ["selectedPartnersForUpdate"]),
  },
  async mounted() {
    console.log("selectedPartnersForUpdate", this.selectedPartnersForUpdate);
    this.init();
  },
};
</script>
